import { useState } from "react";
import EmployeeDetailsTemplate from "templates/users/drivers/employee/employeeDetails";
import DriverComplainHistory from "components/Organisms/users/drivers/employee/driverComplainHistory";
import DriverDetails from "components/Organisms/users/drivers/details";
import DriverOrderHistory from "components/Organisms/users/drivers/driverOrderHistory";
import { handleTabChange } from "services/modules/utils/Helper";
import { useTranslation } from "react-i18next";

export default function EmployeeDetailsPage({ details, actionsList }) {
  const { t } = useTranslation();
  const tabs = [
    {
      title: t("employee_drivers.tab_details"),
      children: <DriverDetails details={details} />,
    },
    {
      title: t("employee_drivers.tab_orders_history"),
      children: <DriverOrderHistory />,
    },
    {
      title: t("employee_drivers.tab_complaints_history"),
      children: <DriverComplainHistory />,
    },
  ];

  const [searchParams, setSearchParams] = useState(
    new URLSearchParams(window.location.search),
  );

  const tabId = searchParams.get("tabId");
  const [value, setValue] = useState(+tabId || 0);

  return (
    <EmployeeDetailsTemplate
      details={details}
      selectedTab={value}
      tabs={tabs}
      handleTabChange={(event, newValue) =>
        handleTabChange({
          event,
          newValue,
          setValue,
          searchParams,
          setSearchParams,
        })
      }
      actionsList={actionsList}
    />
  );
}
